module.exports = __webpack_public_path__ + "media/images/global/icons/certificate-eafed0e1e94bb2b5ac91bad0c475e9df.svg";